import { PrivateInterceptor } from "../../../../Base/interceptors/PrivateInterceptor"; 


// OBTENER REQUISAS PARA LIBERAR REQUISAS
export const getLiberarRequisa = async () => {
  const respuesta = await PrivateInterceptor(`Compras/LiberarRequisa`, "GET");
  return respuesta;
};
